import { Box, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { Footer } from '../../components/footers/Footer';
import { HomeHeader } from '../../components/headers/HomeHeader';
import { PageMain } from '../../components/seo/PageMain';
import { PageSeoHelmet } from '../../components/seo/PageSeoHelmet';
import { FaqAccordion } from './components/FaqAccordion';
import { getFaqsSeo, getMasterFaqs } from './repository';
import { KC_COLORS } from './theme';
import './knowledgeCenter.css';

export function KnowledgeCenterFaqs() {
  return (
    <>
      <PageSeoHelmet {...getFaqsSeo()} />
      <div className="kc-ds w-full overflow-x-hidden bg-white">
        <HomeHeader headerColor="#0D131E" textColor="#ffffff" />
        <PageMain className="knowledge-center-faqs-page">
          <Box className="w-full bg-white pb-12 md:pb-16">
            <Container maxWidth="lg">
              <div className="pt-28 md:pt-32 pb-2 text-left">
                <nav aria-label="Breadcrumb" className="mb-5 md:mb-6">
                  <ol
                    className="flex flex-wrap items-center gap-x-2 gap-y-1 kc-type-body font-semibold"
                    style={{ color: KC_COLORS.navy700 }}
                  >
                    <li>
                      <Link to="/" className="hover:opacity-80">
                        Home
                      </Link>
                    </li>
                    <li className="inline-flex items-center gap-2">
                      <span style={{ color: KC_COLORS.gray600 }}>&gt;</span>
                      <Link to="/knowledge-center" className="hover:opacity-80">
                        Knowledge Center
                      </Link>
                    </li>
                    <li className="inline-flex items-center gap-2">
                      <span style={{ color: KC_COLORS.gray600 }}>&gt;</span>
                      <span style={{ color: KC_COLORS.gray600 }}>FAQs</span>
                    </li>
                  </ol>
                </nav>

                <h1 className="kc-type-h1">Frequently Asked Questions</h1>
                <p className="kc-type-body mt-4 md:mt-5 max-w-3xl" style={{ color: KC_COLORS.gray600 }}>
                  Executive answers to the most important questions about AI in property and
                  casualty insurance — strategy, claims, underwriting, governance, and ROI.
                </p>
              </div>

              <hr
                className="mt-8 md:mt-10 mb-8 md:mb-10 border-0 border-t"
                style={{ borderColor: KC_COLORS.border }}
              />

              <FaqAccordion faqs={getMasterFaqs()} idPrefix="kc-master-faq" />
            </Container>
          </Box>
        </PageMain>
        <Footer />
      </div>
    </>
  );
}
